import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { SEO } from '../../../../components/Seo/seo'
import { useIntl } from 'react-intl'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../../routes'
import { users } from '../../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import CompanyUsersContent from '../../../../components/Dashboard/Workspace/CompanyUsersContent'


const CompanyUsers = () => {
  let { id } = useParams()
  const intl = useIntl()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'Companies.CompanyUsers' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
               image={users.image}
               description={intl.formatMessage({ id: 'Companies.CompanyUsers' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, userData, handleNotificationCall }) => (
              <>
                {!!userDataLoading && <FormLoader loading={true}/>}
                {!!Object.keys(userData).length &&
                <>
                  {!!userData.is_admin ?
                    <Layout content={<CompanyUsersContent cid={id} handleNotificationCall={handleNotificationCall}/>}/> :
                    (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
                  }
                </>
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <Redirect to={NamedRoutes.workspace.company.list}/>
      }
    </>
  )
}

export default CompanyUsers

